module.exports = __webpack_public_path__ + "media/images/numbers-bg-ad573632050e6eeedb2baeb933d8a9f2.png";